export default{
  en: {
    agent: 'Agent',
    back_to_dashboard: 'Back to dashboard',
    click_here_to_choose_a_file: 'Click here to choose a file',
    hello: 'Bienvenue sur GB Agent',
    email: 'Email',
    enterEmail: 'Enter email',
    firstname: 'Firstname',
    first_name_too_long: 'The first name is too long. It should be 30 characters max.',
    kind: 'Category',
    lastname: 'Lastname',
    last_name_too_long: 'The last name is too long. It should be 30 characters max.',
    last_login: 'Last login',
    password: 'Password',
    email_address: 'Email address',
    enterPassword: 'Enter password',
    max_rooms: 'Max number of simultaneous chats',
    notifications_title: 'Notifications',
    submit: 'Submit',
    skills: 'Skills',
    password_recovery: 'Mot de passe oublié ?',
    login_label: 'Se connecter',
    or_drag_it_here: 'Or drag it here',
    password_recovery_title: 'Réinitialiser votre mot de passe',
    password_recovery_btn: 'Réinitialiser le mot de passe',
    password_recovery_login: 'Se connecter',
    password_recovery_new: 'Vous êtes nouveau ?',
    password_recovery_new_label: 'Créer un compte',
    password_change_title: 'Réinitialiser votre mot de passe',
    password_change_new_password1_label: 'New password',
    password_change_new_password2_label: 'Confirm new password',
    errors: {
      email: 'Please enter a valid email',
      password: 'Please enter a 6 digits password',
      wrong_credentials: 'Wrong credentials'
    },
    supervisor: 'Supervisor',
    'unable to find user': 'Unable to find the user',
    noted: 'Noted!',
    you_will_received_email_with_link: 'You will receive a mail with a link that let you change your password.',
    'bad token': 'Bad or too old token',
    my_parameters: 'My parameters',
    want_daily_reports_label: 'Receive daily reports',
    want_notifications_label: 'Receive notifications',
    bad_authentication: 'Wrong credentials',
    unauthorized: 'You are not authorized to perform this action',
    agent_does_not_exist: 'The specified agent doesn\'t exist',
    room_does_not_exist: 'The room doesn\'t exist',
    agent_paused: 'You cannot do this action while in pause mode',
    cant_close_this_room: 'You cannot close this room',
    cant_block_this_room: 'You cannot block this room',
    cant_transfer_this_room: 'You cannot transfer this room',
    skill_does_not_exist: 'The specified skill doesn\'t exist',
    content_required: 'The message content is required',
    bad_rich_content: 'The rich content is invalid',
    event_does_not_exist: 'The specified event doesn\'t exist',
    interval_missing: 'The interval is missing',
    bad_interval: 'The specified interval is incorrect',
    skill_or_agent_required: 'The agent or skill field is missing',
    previous_notes: 'Previous notes',
    le_before_date: '',
    date_at: 'at',
    max_rooms_reached: 'You already reached your maximum amount of running conversations at the same time.',
    agent_on_pause: "Pour envoyer un message, veuillez s'il vous plait cliquer sur 'revenir de pause'",
    discussions_title: 'Discussions',
    running_title: 'Running',
    late_title: 'Late',
    waiting_title: 'Waiting',
    closed_title: 'Closed',
    channels_title: 'Other Channels',
    conversation_title: 'New conversation',
    'The file is too big': 'The file is too big',
    'The file format is not allowed': 'The file format is not allowed',
    file_format_not_allowed: 'File format not allowed',
    file_required: 'Please provide a file',
    file_too_big: 'The file is too big',
    unknown_file_format: 'Unknown file form',
    not_authenticated: 'Not authenticated'
  },
  fr: {
    agent: 'Agent',
    back_to_dashboard: 'Retour aux discussions',
    click_here_to_choose_a_file: 'Cliquer ici pour choisir un fichier',
    hello: 'Bienvenue',
    email: 'Email',
    enterEmail: 'Entrez un email',
    firstname: 'Prénom',
    first_name_too_long: 'Le prénom est trop long. Il doit faire 30 caractères maximum.',
    kind: 'Catégorie',
    lastname: 'Nom',
    last_name_too_long: 'Le nom est trop long. Il doit faire 30 caractères maximum.',
    last_login: 'Dernière connexion',
    or_drag_it_here: 'Ou faites-le glisser ici',
    password: 'Mot de passe',
    email_address: 'Adresse email',
    enterPassword: 'Entrez un mot de passe',
    max_rooms: ' Nombre de discussions simultanées maximales',
    notifications_title: 'Notifications',
    skills: 'Compétences',
    submit: 'Valider',
    password_recovery: 'Mot de passe oublié ?',
    login_label: 'Se connecter',
    password_recovery_title: 'Réinitialisez votre mot de passe',
    password_recovery_btn: 'Réinitialiser le mot de passe',
    password_recovery_login: 'Se connecter',
    password_recovery_new: 'Vous êtes nouveau ?',
    password_recovery_new_label: 'Créer un compte',
    password_change_title: 'Réinitialiser votre mot de passe',
    password_change_new_password1_label: 'Nouveau mot de passe',
    password_change_new_password2_label: 'Confirmer le nouveau mot de passe',
    new_password1: 'nouveau mot de passe',
    new_password2: 'confirmation du nouveau mot de passe',
    errors: {
      email: 'L\' adresse email n\'est pas valide',
      password: 'Le mot de passe doit contenir au moins 6 caractères',
      wrong_credentials: 'Email ou mot de passe incorrect'
    },
    supervisor: 'Superviseur',
    'unable to find user': 'Impossible de trouver l\'utilisateur',
    noted: 'C\'est noté&nbsp;!',
    'you_will_received_email_with_link': 'Vous allez recevoir un mail avec un lien vous permettant de changer votre mot de passe.',
    'bad token': 'Jeton d\'authentification erroné ou trop vieux.',
    my_parameters: 'Mes paramètres',
    want_daily_reports_label: 'Recevoir les rapports quotidiens',
    want_notifications_label: 'Recevoir des notifications',
    bad_authentication: 'Email ou mot de passe incorrect',
    not_authenticated: 'Vous n\'êtes pas connecté',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action',
    agent_does_not_exist: 'Cet agent n\'existe pas',
    room_does_not_exist: 'Cette conversation n\'existe pas',
    agent_paused: 'Vous ne pouvez pas effectuer cette action lorsque vous êtes en pause',
    cant_close_this_room: 'Vous ne pouvez pas fermer cette conversation',
    cant_block_this_room: 'Vous ne pouvez pas bloquer cette conversation',
    cant_transfer_this_room: 'Vous ne pouvez pas transférer cette conversation',
    skill_does_not_exist: 'Cette compétence n\'existe pas',
    content_required: 'Le contenu du message est nécessaire',
    bad_rich_content: 'Ce contenu n\'est pas valide',
    event_does_not_exist: 'Cet événement n\'existe pas',
    interval_missing: 'The interval is missing',
    bad_interval: 'The specified interval is incorrect',
    skill_or_agent_required: 'L\'agent ou le champ de compétence est vide',
    previous_notes: 'Notes antérieures',
    le_before_date: 'Le',
    date_at: 'à',
    max_rooms_reached: 'Vous avez déjà atteint votre nombre maximum de conversations en cours simultanées.',
    agent_on_pause: "Pour envoyer un message, veuillez s'il vous plait cliquer sur 'revenir de pause'",
    discussions_title: 'Discussions',
    running_title: 'En cours',
    late_title: 'En retard',
    waiting_title: 'En attente',
    closed_title: 'Fermé',
    channels_title: 'Autres Canaux',
    conversation_title: 'Nouvelle conversation',
    'The file is too big': 'Le fichier est trop gros',
    'The file format is not allowed': 'Le format du fichier n\'est pas autorisé',
    file_format_not_allowed: 'Format de fichier non autorisé',
    file_required: 'Veuillez fournir un fichier',
    file_too_big: 'Le fichier est trop gros',
    unknown_file_format: 'Format de fichier inconnu'
  }
}
